import * as React from 'react';

import { useLocation } from 'js/lib/useRouter';

import LandingPageRedesignContent from 'bundles/coursera-plus-landing-page/components/redesign/LandingPageContentfulContent';
import type { PropsFromLandingPageCaller } from 'bundles/coursera-plus-landing-page/contentfulData/LandingPageDataProvider';
import LandingPageDataProvider from 'bundles/coursera-plus-landing-page/contentfulData/LandingPageDataProvider';
import ProfitwellTag from 'bundles/payments/utils/ProfitwellTag';

const LandingPageContentful = ({ landingPage, hideRegionalPromotionBanner }: PropsFromLandingPageCaller) => {
  const { query } = useLocation();
  const retryProcessor: string | undefined = query?.retryProcessor;

  return (
    <LandingPageDataProvider landingPage={landingPage} hideRegionalPromotionBanner={hideRegionalPromotionBanner}>
      {retryProcessor && <ProfitwellTag processor={retryProcessor} />}
      <LandingPageRedesignContent />
    </LandingPageDataProvider>
  );
};

export default LandingPageContentful;
